<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">充电时长包管理</h3> 
        <div class="block-options">
          <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="create('add')"
          >
            <i class="fa fa-plus mr-1"></i> 新增
          </button>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <!-- <div class="block-content block-content-full"> -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtn"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <table
                  id="chargePiePkg"
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('ID',$event)"
                      >#</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:120px;"
                        @click="getList('SITE_NAME',$event)"
                      >适用范围</th>
                      <th
                        class="text-left sorting"
                        style="min-width:120px;"
                        @click="getList('PACKAGE_TYPE_STR',$event)"
                      >时长包类型</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:95px;"
                        @click="getList('DESCRIPTION',$event)"
                      >时长包名</th>

                      <th
                        class="text-left sorting"
                        style="min-width: 105px;"
                        @click="getList('DURATION',$event)"
                      >有效时长</th>
                      <th
                        class="text-left sorting"
                        style="width: 110px;min-width: 110px;"
                        @click="getList('VALID_TIME',$event)"
                      >有效月数</th>
                      <th
                        class="text-left sorting"
                        style="width: 110px;min-width: 110px;"
                        @click="getList('VALID_TIME',$event)"
                      >有效天数</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:95px;"
                        @click="getList('PAY_MONEY',$event)"
                      >价格(元)</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:140px;"
                        @click="getList('LIMIT_DURATION',$event)"
                      >每日限制时长</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:140px;"
                        @click="getList('RESET_HOUR',$event)"
                      >每日重置时间</th>
                      <!-- <th
                          class="text-center d-xl-table-cell sorting"
                          style="min-width:110px;"
                          @click="getList('BIG_PACKAGE_TYPE',$event)"
                      >车棚附加包</th>-->
                      <th
                        class="text-center d-xl-table-cell sorting"
                        style="min-width:140px;"
                        @click="getList('BIG_PACKAGE_TYPE',$event)"
                      >仅白名单用户</th>
                      <th
                        class="text-center d-xl-table-cell sorting"
                        style="min-width:80px;"
                        @click="getList('STATE',$event)"
                      >状态</th>
                      <!-- <th
                          class="text-left d-md-table-cell sorting"
                          style="min-width:100px;"
                          @click="getList('PACKAGE_ID',$event)"
                      >时长包ID</th>-->
                      <!-- <th
                          class="text-left sorting"
                          @click="getList('BIG_PACKAGE_TYPE',$event)"
                          style="width: 160px;min-width: 120px;"
                      >适用范围</th>-->
                      <!-- <th class="text-left d-xl-table-cell"
                      style="min-width:85px;">功率类型</th>-->
                      <!-- <th
                          class="text-center d-xl-table-cell sorting"
                          style="min-width:80px;"
                          @click="getList('STATE',$event)"
                      >状态</th>-->
                      <th
                        class="text-center"
                        style="width: 100px; min-width:100px"
                        v-if="editBtn "
                      >操作</th>
                    </tr>
                  </thead>
                  <tbody v-if="agents.length">
                    <tr v-for="(agent, i) in agents" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left">{{ agent.SITE_NAME }}</td>
                      <td class="text-left">{{ agent.PACKAGE_TYPE_STR }}</td>
                      <td class="text-left">{{ agent.DESCRIPTION }}</td>
                      <td class="text-left">{{ agent.DURATION}}小时</td>
                      <td class="text-left">{{ agent.VALID_STR}}</td>
                      <td
                        class="text-left"
                      >{{ agent.PACKAGE_TYPE!=4?(agent.VALID_TIME>0?agent.VALID_TIME+"天":"-"):"-"}}</td>
                      <td
                        class="text-left d-xl-table-cell"
                      >{{ agent.PAY_MONEY==0?"免费":changeTwoDecimal(agent.PAY_MONEY) }}</td>
                      <td
                        class="text-left"
                      >{{ agent.LIMIT_DURATION=="0"?"无限制":agent.LIMIT_DURATION+"小时"}}</td>
                      <td class="text-left">{{ agent.RESET_HOUR}}</td>

                      <!-- <td class="text-center">badge-success
                          <li
                            v-if="agent.BIG_PACKAGE_TYPE == 1"
                            class="si si-check text-success center"
                          ></li>
                      </td>-->
                      <td class="text-center">
                        <!-- <div class="custom-control custom-switch custom-control-primary">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            name="example-sw-primary2"
                            :checked="agent.BIG_PACKAGE_TYPE == 2 ? true  : false"
                            disabled
                          />
                          <label
                            class="custom-control-label"
                            :for="'dexample-sw-custom-success-state' + agent.ROWNUM"
                          ></label>
                        </div>-->
                        <i
                          class="fa"
                          :class="agent.BIG_PACKAGE_TYPE == 2 ? 'fa-check-circle text-success' : 'fa-minus-circle text-gray'"
                        ></i>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge badge-pill"
                          :class="agent.STATE == '0' ? 'badge-success' : 'badge-secondary'"
                        >{{ agent.STATE == "0" ? "启用" : "禁用"}}</span>
                      </td>

                      <!-- <td class="text-left">
                          <a
                            href="javascrpit:void(0)"
                            data-toggle="modal"
                            @click="create('',agent.PACKAGE_ID)"
                          >
                            {{ agent.PACKAGE_ID
                            }}
                          </a>
                      </td>-->
                      <!-- <td class="text-left">{{ showType(agent.BIG_PACKAGE_TYPE)}}</td> -->
                      <!-- <td class="text-left text-left d-xl-table-cell">{{ agent.POWER_TYPE_ID }}档</td> -->
                      <!-- <td class="text-center">
                          <div class="custom-control custom-switch custom-control-primary">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              name="example-sw-primary2"
                              :checked="agent.STATE == 1 ? false : true"
                              disabled
                            />
                            <label
                              class="custom-control-label"
                              :for="'dexample-sw-custom-success-state' + agent.ROWNUM"
                            ></label>
                          </div>
                      </td>-->

                      <td class="text-center" v-if="editBtn ||stateBtn">
                        <div class="btn-group">
                          <button
                            title="查看"
                            v-if="editBtn"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            data-original-title="Edit"
                            data-toggle="modal"
                            @click="create('edit',agent.PACKAGE_ID)"
                          >
                            <i class="fa fa-search"></i>
                          </button>
                          <!-- <button
                            v-if="stateBtn"
                            title="编辑状态"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            data-original-title="Edit"
                            @click="createSet(agent)"
                          >
                            <i class="fa fa-user-cog"></i>
                          </button>-->
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="13">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="agents && agents.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div
      class="modal fade"
      id="modal-default-normal-systemEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-systemEdit"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{edit=='add'?'新增充电时长包':'充电包费率详情'}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <!-- <div class="form-group" v-show="edit != 'add'">
                <label class="col-sm-12 control-label">时长包ID</label>
                <div class="col-sm-12">
                  <input
                    disabled
                    class="form-control"
                    placeholder
                    v-model=" form.packageId"
                    maxlength="30"
                  />
                </div>
              </div>-->
              <div class="form-group" v-show="edit!='edit'">
                <label for="cell-sel" class="col-sm-5 control-label">
                  所在区域
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control width-33"
                    id="cell-province-sel"
                    name="cell-province-sel"
                    @change="provinceSel()"
                    v-model="pro"
                    :disabled="edit==''"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in provinceList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control width-33"
                    @change="citySel()"
                    v-model="city"
                    :disabled="edit==''"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cityList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select
                    class="form-control width-33"
                    @change="disSel()"
                    v-model="dis"
                    :disabled="edit==''"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in districtList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    v-show="edit=='add'"
                    class="form-control"
                    style="display:inline-block;"
                    v-model=" form.cellId"
                    :disabled="edit==''"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-show="edit=='edit'"
                    disabled
                    v-model="form.cellName"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">站点名称</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-show="edit=='edit'"
                    disabled
                    v-model="siteName"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  时长包类型
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    :value="form.packageType==4?2:form.packageType"
                    :disabled="edit!='add'"
                    @change="chengType()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in packgeType"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  有效时长
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    :disabled="edit!='add'"
                    type="text"
                    class="form-control"
                    v-model=" form.duration"
                    maxlength="16"
                    @blur="durationBlur()"
                    placeholder="小时"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">时长包名</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="form.customName"
                    placeholder="请输入"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-nature" class="col-sm-12 control-label">
                  有效月数
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model=" form.validMonth" disabled>
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in 13"
                      :key="index"
                      :value="index+'' "
                    >{{ index==0?'本月月底失效':index==1?'次月月底失效':index+'个月后月底失效'}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-nature" class="col-sm-12 control-label">
                  有效天数
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model=" form.validTime"
                    maxlength="16"
                    placeholder="天"
                    :disabled="form.packageType=='2' || edit!='add'"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-nature" class="col-sm-12 control-label">
                  价格(元)
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    :disabled="edit!='add'"
                    type="text"
                    class="form-control"
                    v-model=" form.payMoney"
                    placeholder="元"
                    maxlength="16"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">每日限制时长</label>
                <div class="col-sm-12">
                  <!-- <input
                    :disabled="edit==''"
                    type="text"
                    class="form-control"
                    v-model=" form.limit_duration"
                    maxlength="16"
                  />-->
                  <select :disabled="true" class="form-control" v-model=" form.limit_duration">
                    <option selected="selected" disabled="disabled" value>无限制</option>
                    <option v-for="(item,index) in 25" :key="index" :value="item-1">{{item-1}}小时</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-auth-type" class="col-sm-12 control-label">每日重置时间</label>
                <div class="col-sm-12">
                  <select class="form-control" v-model=" form.reset_hour" :disabled="true">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in 24"
                      :key="index"
                      :value="index>9?index + ':00':'0'+index+':00'"
                    >{{index>9?index + ':00':'0'+index+':00'}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group form-group-50">
                <label for="cell-auth-type" class="col-sm-12 control-label">
                  仅白名单用户
                  <span class="input-required" v-show="edit=='add'">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    v-show="edit!='add'&&(form.big_package_type==0||form.big_package_type==2)"
                    class="form-control"
                    :disabled="edit!='add'"
                    v-model="form.big_package_type"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in yesOrNo"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                  <select
                    v-show="edit!='add'&&!(form.big_package_type==0||form.big_package_type==2)"
                    class="form-control"
                    :disabled="edit!='add'"
                    :value="form.big_package_type==2?2:0"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in yesOrNo"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">适用范围</label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    
                    v-model=" form.big_package_type"
                    :disabled="edit==''"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in userType"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>-->
              <!-- <div class="form-group form-group-50">
                <label for="cell-nature" class="col-sm-12 control-label">备注</label>
                <div class="col-sm-12">
                  <input
                    :disabled="edit==''"
                    type="text"
                    class="form-control"
                    v-model=" form.remark"
                    maxlength="16"
                  />
                </div>
              </div>-->
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <!-- <button
              v-if="edit!=''"
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit()"
            >保存</button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      agents: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      packgeType: [
        {
          value: "1",
          label: "普通"
        },
        {
          value: "2",
          label: "月底清零"
        },
        {
          value: "3",
          label: "车棚叠加包"
        }
      ],
      userType: [
        {
          value: "0",
          label: "普通用户"
        },
        {
          value: "1",
          label: "叠加停车包套餐"
        },
        {
          value: "2",
          label: "白名单用户"
        }
      ],
      yesOrNo: [
        {
          value: "2",
          label: "是"
        },
        {
          value: "0",
          label: "否"
        }
      ],
      form: {
        packageId: "",
        powerTypeId: "",
        packageType: "",
        payMoney: "",
        duration: "",
        validTime: "",
        description: "",
        remark: "",
        cellId: "",
        cellName: "",
        big_package_type: "",
        limit_duration: "",
        reset_hour: "",
        packageName: "",
        customName: "",
        validMonth: ""
      },
      siteName: "",
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      pro: "",
      city: "",
      dis: "",
      edit: "",
      sorting: "",
      orderBy: false,
      addBtn: Util.isHavePerm("timeLen/addTimeLen"),
      editBtn: Util.isHavePerm("timeLen/editTimeLen"),
      stateBtn: Util.isHavePerm("timeLen/updateState")
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "form.duration"(val, oldVal) {
      this.form.duration = Util.testNumberFn(val, "inputChangeNoDecimal");
    },
    "form.validTime"(val, oldVal) {
      this.form.validTime = Util.testNumberFn(val, "inputChangeNoDecimal");
    },
    "form.limit_duration"(val, oldVal) {
      this.form.limit_duration = Util.testNumberFn(val, "inputChangeNoDecimal");
    },
    "form.payMoney"(val, oldVal) {
      this.form.payMoney = Util.testNumberFn(val, "inputChangeTwoDecimal");
    },
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    // this.getEntry()
    this.getProvince();
    this.getList();
    this.copy();
    // setTimeout(() => {
    //   $('#chargePiePkg').DataTable({
    //     scrollX: true,
    //     searching: false,//搜索
    //     info: false,
    //     scrollCollapse: true,
    //     paging: false,
    //     fixedColumns: {
    //         leftColumns: 0,
    //         rightColumns: 1
    //     },
    //     drawCallback: function(){
    //         //重绘的回调执行
    //     }
    // } );
    // }, 3000);
  },
  methods: {
    durationBlur() {
      if (this.form.duration) {
        this.form.customName = this.form.duration + "小时";
      }
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    createSet(val) {
      // 1禁用0启用
      let text = val.STATE == 0 ? "确定禁用？" : "确定启用？";
      swal(text, {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.switchChange(val);
            break;
        }
      });
    },
    switchChange(val) {
      this.$http
        .post(`${Util.operateURL}/timeLen/updateState`, {
          state: val.STATE == 0 ? 1 : 0,
          packageId: val.PACKAGE_ID
        })
        .then(res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        }),
        err => {
          console.log(err);
        };
    },
    chengType() {
      if (this.form.packageType == "2") {
        this.form.validTime = "";
      }
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Package/SystemDurationListBy/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    provinceSel() {
      let pid = $(`#cell-province-sel`).val();
      this.$http.get(`${Util.searchURL}/City/ListByProvince/${this.pro}`).then(
        res => {
          if (res.data.code === 200) {
            this.cityList = res.data.data;
            this.city = "";
            this.districtList = [];
            this.dis = "";
            this.cellList = [];
            this.form.cellId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    citySel() {
      this.$http.get(`${Util.searchURL}/District/ListByCity/${this.city}`).then(
        res => {
          if (res.data.code === 200) {
            this.districtList = res.data.data;
            this.dis = "";
            this.cellList = [];
            this.form.cellId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    // getCellList() {
    //   this.$http.get(`${Util.searchURL}/FlatComplex/SearchBy?key=`).then(
    //     res => {
    //       if (res.data.code === 200) {
    //         this.cellList = res.data.data;
    //       }
    //     },
    //     err => {
    //       console.log(err);
    //     }
    //   );
    // },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
              this.form.cellId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    showType(val) {
      switch (val) {
        case "0":
          return "普通用户";
        case "1":
          return "叠加停车包套餐";
        case "2":
          return "白名单用户";
      }
    },
    search() {
      this.page = 1;
      this.getList();
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      this.$http
        .get(
          `${Util.searchURL}/Package/SystemDurationListBy/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    create(val, id) {
      jQuery("#modal-default-normal-systemEdit").modal("show");
      this.edit = val;
      if (val == "add") {
        this.form = {
          packageId: "",
          powerTypeId: "",
          packageType: "",
          payMoney: "",
          duration: "",
          validTime: "",
          description: "",
          remark: "",
          cellId: "",
          cellName: "",
          big_package_type: "",
          limit_duration: "",
          reset_hour: "",
          packageName: "",
          customName: "",
          validMonth: ""
        };
        this.pro = "";
        this.city = "";
        this.dis = "";
        this.cityList = [];
        this.districtList = [];
        this.cellList = [];
      } else {
        this.getDetail(id);
      }
    },
    getDetail(id) {
      this.$http.get(`${Util.searchURL}/Package/SystemDurationGet/${id}`).then(
        res => {
          if (res.data.code === 200) {
            let d = res.data.data;
            this.form = {
              packageId: d.PACKAGE_ID,
              powerTypeId: d.POWER_TYPE_ID,
              packageType: d.PACKAGE_TYPE,
              payMoney: Util.changeTwoDecimal(d.PAY_MONEY),
              duration: d.DURATION,
              validTime:
                d.PACKAGE_TYPE == 1 || d.PACKAGE_TYPE == 3 ? d.VALID_TIME : "",
              description: d.DESCRIPTION,
              remark: d.REMARK,
              cellId: d.CELL_ID,
              cellName: d.CELL_NAME,
              big_package_type: d.BIG_PACKAGE_TYPE,
              limit_duration: d.LIMIT_DURATION,
              reset_hour: d.RESET_HOUR,
              packageName: d.DESCRIPTION,
              customName: d.DESCRIPTION,
              validMonth:
                d.PACKAGE_TYPE == 2 || d.PACKAGE_TYPE == 4 ? d.VALID_TIME : ""
            };
            this.siteName = d.SITE_NAME;
            Util.displayAreaCell(
              d.CELL_ID,
              this,
              true,
              this.edit == "" ? true : false
            );
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    submit() {
      let url = "";
      if (this.edit == "add") {
        url = `${Util.operateURL}/timeLen/addTimeLen`;
      } else {
        url = `${Util.operateURL}/timeLen/editTimeLen`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal-systemEdit").modal("hide");
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    }
  }
};
</script>